import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import Autocomplete from 'react-autocomplete';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import StateOptions from '../../Common/StateOptions/StateOptions';
import ProvinceOptions from '../../Common/ProvinceOptions/ProvinceOptions';
import CountryOptions from '../../Common/CountryOptions/CountryOptions';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ClientInfo extends Component {
    constructor(props) {
		super(props);
		this.state = { 
			fullAutocompleteData: [],
			autocompleteData: [],
		}
    }

    onChange = (e) => {
		let value = e.target.value;
		this.props.handleBillingAddressChange(e.target.value);

        const doGetAutocomplete = async (value) => {
            try {
                const autocompleteResponse = await getAutocomplete(value);
				console.log('autocompleteResponse: ', autocompleteResponse);
				const autocompleteData = autocompleteResponse.data.predictions.map((prediction) => {
					const myObject = {
						'label': prediction.description,
						'value': prediction.place_id,
					}
					return myObject;
				});
				this.setState({
					fullAutocompleteData: autocompleteResponse.data.predictions,
                    autocompleteData,
                });
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAutocomplete(value) {
            return await ApiRequest('/google/place-search', {
                method: 'POST',
                data: {
                    input: `${value}`,
                }
            });
        }
		if (value.length >= 5) {
			doGetAutocomplete(value);
		}
	}
	
	onSelect = (value) => {
        const fullAutocompleteData = this.state.fullAutocompleteData;
		let place_id = '';
		fullAutocompleteData.forEach((data) => {
			if (data.place_id === value) {
				place_id = data.place_id;
			}
        });
        
        const doGetAddress = async (value) => {
            try {
                const addressResponse = await getAddress(value);
                console.log('addressResponse: ', addressResponse);
                this.props.handleFullBillingAddressChange(addressResponse.data);
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAddress(value) {
            return await ApiRequest('/google/place-detail', {
                method: 'POST',
                data: {
                    placeid: `${value}`,
                }
            });
        }
        doGetAddress(place_id);
	}

	renderItem = (item, isHighlighted) =>{
        return (
            <div className="item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>   
        ); 
	}
	
	getItemValue= (item) =>{
        return `${item.value}`;
    }
    
    render() { 
        return ( 
            <div className="showtix-section showtix-background__primary-1">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <h1>{strings.title}</h1>

                            <div className="row">
                                <div className="col-12 col-md-6 order-1 order-md-1">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="business-name">{strings.orgName}*
                                            <span id="tooltip-orgName" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-orgName">
                                                {strings.orgNameTooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input 
                                                className="showtix-input" 
                                                id="business-name"
                                                type="text" 
                                                name="client_name" 
                                                value={this.props.client.client_name} 
                                                validation="(^(?!\s*$).+)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                readOnly="true"
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.client_name.valid &&
                                            <div className="showtix-note error">
                                            {this.props.validation.client_name.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 order-6 order-md-2">
                                    <div className={"showtix-form__group " + (this.props.validation.billing_address_1.valid === false && this.props.client.billing_address_1 !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="billing-address-1">{strings.orgBillingAddress1}*
                                                <span id="tooltip-orgBillingAddress1" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-orgBillingAddress1">
                                                    {strings.orgBillingAddress1Tooltip}
                                                </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <Autocomplete
												getItemValue={this.getItemValue}
												items={this.state.autocompleteData}
												renderItem={this.renderItem}
												value={this.props.client.billing_address_1}
												onChange={this.onChange}
                                                onSelect={this.onSelect}
                                                onBlur={this.props.validateRequiredField}
                                                required 
												menuStyle={{
													background: '#fff',
													padding: '0',
													position: 'absolute',
													top: '44px',
													left: '0',
													right: '0',
													overflow: 'auto',
													zIndex: '2',
													maxHeight: '200px',
												}}
											/>
                                        </div>
                                        {!this.props.validation.billing_address_1.valid &&
                                            <div className="showtix-note error">
                                                {this.props.validation.billing_address_1.msg}
                                            </div>
                                        }
                                    </div>
                                </div>
                            
                                <div className="col-12 col-md-6 order-2">
                                    <div className={"showtix-form__group " + (this.props.validation.client_email.valid === false && this.props.client.client_email !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="business_email">{strings.orgEmail}*
                                            <span id="tooltip-orgEmail" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-orgEmail">
                                                {strings.orgEmailTooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                type="text"
                                                className="showtix-input"
                                                placeholder={strings.enterEmail}
                                                id="business_email"
                                                name="client_email"
                                                value={this.props.client.client_email}
                                                validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.client_email.valid &&
                                            <div className=" showtix-note error">
                                            {this.props.validation.client_email.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 order-7 order-md-3">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="business-address-2">{strings.orgBillingAddress2}</label>
                                        <div className="showtix-form__input">
                                            <input
                                                className="showtix-input"
                                                autoComplete="disabled"
                                                id="business-address-2"
                                                type="text"
                                                name="billing_address_2"
                                                value={this.props.client.billing_address_2}
                                                onChange={this.props.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                           
                                <div className="col-12 col-md-6 order-3">
                                    <div className={"showtix-form__group " + (this.props.validation.client_phone.valid === false && this.props.client.client_phone !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="business_phone">{strings.orgPhone}*
                                            <span id="tooltip-orgPhone" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-orgPhone">
                                                {strings.orgPhoneTooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                type="text"
                                                className="showtix-input"
                                                placeholder="Enter a phone number"
                                                id="business_phone"
                                                name="client_phone"
                                                value={this.props.client.client_phone}
                                                validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.client_phone.valid &&
                                            <div className=" showtix-note error">
                                            {this.props.validation.client_phone.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 order-8 order-md-4">
                                    <div className={"showtix-form__group " + (this.props.validation.billing_city.valid === false && this.props.client.billing_city !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="billing-city">{strings.billingCity}*</label>
                                        <div className="showtix-form__input">
                                            <input className="showtix-input"
                                                id="billing-city"
                                                type="text"
                                                name="billing_city"
                                                value={this.props.client.billing_city}
                                                validation="(^(?!\s*$).+)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.billing_city.valid &&
                                            <div className=" showtix-note error">
                                            {this.props.validation.billing_city.msg}
                                            </div>
                                        }
                                    </div>
                                </div>
                            
                                <div className="col-12 col-md-6 order-4">
                                    <div className={"showtix-form__group " + (this.props.validation.billing_contact.valid === false && this.props.client.billing_contact !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="billing-contact">{strings.billingContact}*
                                            <span id="tooltip-billingContact" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-billingContact">
                                                {strings.billingContactTooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input className="showtix-input"
                                                type="text"
                                                id="billing-contact"
                                                name="billing_contact"
                                                value={this.props.client.billing_contact}
                                                validation="(^(?!\s*$).+)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.billing_contact.valid &&
                                            <div className=" showtix-note error">
                                            {this.props.validation.billing_contact.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 order-9 order-md-8">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="billing-country">{strings.billingCountry}*</label>
                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                id="billing-country"
                                                name="billing_country"
                                                value={this.props.client.billing_country}
                                                onChange={this.props.handleChange}
                                            >
                                                <CountryOptions />
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            
                                <div className="col-12 col-md-6 order-5 order-md-9">
                                    
                                </div>
                                <div className="col-12 col-md-6 order-10 order-md-10">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="billing-state">{strings.billingState}*</label>
                                        <div className="showtix-form__select">
                                            {this.props.client.billing_country === "US" || this.props.client.billing_country === ""?
                                                <select className="showtix-input"
                                                    id="billing-state"
                                                    name="billing_state"
                                                    value={this.props.client.billing_state}
                                                    onChange={this.props.handleChange}>
                                                    <StateOptions />
                                                </select>
                                                :
                                                <select 
                                                    className="showtix-input" 
                                                    name="billing_state" 
                                                    value={this.props.client.billing_state} 
                                                    onChange={this.props.handleChange}>
                                                    <ProvinceOptions />
                                                </select>
                                            }
                                        </div>
                                    </div>
                                </div>
                            
                                <div className="col-12 col-md-6 order-7 order-md-11">
                                    
                                </div>

                                <div className="col-12 col-md-6 order-11 order-md-12">
                                    <div className={"showtix-form__group " + (this.props.validation.billing_zip.valid === false && this.props.client.billing_zip !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="billing-zip">{strings.billingZip}*</label>
                                        <div className="showtix-form__input">
                                            <input
                                                type="text"
                                                className="showtix-input"
                                                placeholder={strings.billingZip}
                                                id="billing-zip"
                                                name="billing_zip"
                                                value={this.props.client.billing_zip}
                                                validation="(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)"
                                                onChange={this.props.handleChange}
                                                onBlur={this.props.validateRequiredField}
                                                required 
                                            />
                                        </div>
                                        {!this.props.validation.billing_zip.valid &&
                                            <div className=" showtix-note error">
                                            {this.props.validation.billing_zip.msg}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-12 col-md-6">
                                    <button 
                                        type="button" 
                                        className="showtix-button showtix-background__primary-2"
                                        disabled={!this.props.isReadyToSubmit}
                                        onClick={this.props.updateClient}
                                    >
                                        <span>{strings.update}</span>
                                    </button>
                                </div>
                            </div> */}

                        </div>
                        { strings.helps &&
                            <div className="col-12 col-lg-4">
                                {strings.helps.map((help, i) =>
                                    <Help help={help} key={i} /> 
                                )}
                            </div>	
                        }
                    </div>
                </div>
            </div>    
        )
    }
}

ClientInfo.propTypes = {
    client: PropTypes.shape({
        client_name: PropTypes.string,
        billing_address_1: PropTypes.string,
        billing_address_2: PropTypes.string,
        client_email: PropTypes.string,
        client_phone: PropTypes.string,
        billing_city: PropTypes.string,
        billing_contact: PropTypes.string,
        billing_country: PropTypes.string,
        billing_state: PropTypes.string,
        billing_zip: PropTypes.string
    }),
    validation: PropTypes.shape({
        client_name: PropTypes.shape({
            valid: PropTypes.bool, 
            msg: PropTypes.string
        }),
        billing_address_1: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_address_2: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        client_email: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        client_phone: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_city: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_contact: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_country: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_state: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        }),
        billing_zip: PropTypes.shape({
            valid: PropTypes.bool,
            msg: PropTypes.string
        })
    }),
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
    updateClient: PropTypes.func,
    isReadyToSubmit: PropTypes.bool
}
 
export default ClientInfo;


// WEBPACK FOOTER //
// ./src/components/ClientPreferences/ClientInfo/ClientInfo.js